import userManagementIcon from "../assets/images/userManagement.svg"
import apiSettingsIcon from "../assets/images/apiSettings.svg"
import subscriptionsIcon from "../assets/images/subscriptions.svg"
import analytics from "../assets/images/analytics.svg"
import dashboardIcon from "../assets/images/dashboardIcon.svg"
import settingsIcon from "../assets/images/settings.svg"
import privacyPolicy from "../assets/images/privacyPolicy.svg"
import totalUsers from "../assets/images/totalUsers.svg"
import activeJobs from "../assets/images/activeJobs.svg"
import monthlyRevenue from "../assets/images/monthlyRevenue.svg"
import systemHealth from "../assets/images/systemHealth.svg"
import privacyPolicyEdit from "../assets/images/privacyPolicyEdit.svg"
import viewUser from "../assets/images/viewUser.svg"
import editUser from "../assets/images/editUser.svg"
import deleteUser from "../assets/images/deleteUser.svg"
import editUserWhite from "../assets/images/editUserWhite.svg"
import deleteUserWhite from "../assets/images/deleteUserWhite.svg"
import termsAndConditions from "../assets/images/Terms and Condition.svg"

export const sidebar = {
    dashboard : dashboardIcon,
    userManagement : userManagementIcon,
    apiSettings:apiSettingsIcon,
    subscriptions : subscriptionsIcon,
    analytics,
    settings : settingsIcon,
    privacyPolicy,
    termsAndConditions,
    
}

export const dashboard ={
    totalUsers,
    activeJobs,
    monthlyRevenue,
    systemHealth,
}
export const userManagement ={
    viewUser,
    editUser,
    deleteUser,
    editUserWhite,
    deleteUserWhite,
}

export const login ={
    login : require("../assets/images/login.png"),
    logo: require("../assets/images/logo.png"),
}

export const apiSettings ={
    privacyPolicyEdit ,
}